import { createSelector } from 'reselect'
import memoize from 'lodash.memoize'

import * as constants from './playerConstants'


const playerState = (state) => (state.player)

/**
 * Récupère la file d'attente du player depuis le state
 *
 * @param state
 */
export const getPlayqueue = createSelector(
	playerState,
	player => (
		player.playQueue
	)
)


/**
 * Retourne la liste de lecture
 *
 * @param state
 * @return Array d'id
 */
export const getPlayqueueTracks = createSelector(
	getPlayqueue,
	playqueue => (
		playqueue.queue
	)
)

export const getPlayqueueIndex = createSelector(
	getPlayqueue,
	playqueue => (
		playqueue.currentIndex
	)
)

/**
 * Récupère les informations de lecture de la track courante
 *
 * @param state
 */
export const getPlayingInfo = createSelector(
	playerState,
	player => (
		player.playingInfo
	)
)

export const getPlayingInfoEssential = createSelector(
	(state) => getPlayingInfo(state).playing,
	(state) => getPlayingInfo(state).buffering,
	(state) => getPlayingInfo(state).currentGetFileUrl,
	(playing, buffering, getFileUrl) => ({
		playing,
		buffering,
		getFileUrl
	})
)


/**
 * Si la track précédente est elle-même (file au début), retourne false, sinon retourne l'index de la track précédente au sein de la file d'attente
 * selon le loopmode et le currentIndex dans la playqueue
 *
 * @param state
 * @returns Boolean | Integer
 * @private
 */
export const getPreviousTrackIndex = createSelector(
	getPlayqueue,
	getPlayqueueIndex,
	(queue, currentIndex) => {
		let previousIndex = false
		if (currentIndex - 1 >= 0) {
			previousIndex = currentIndex - 1
		}
		return previousIndex
	}
)


/**
 * Si la track suivante est elle-même (file finie), retourne false, sinon retourne l'index de la track suivante au sein de la file d'attente
 * selon le loopmode et le currentIndex dans la playqueue
 *
 * @param state
 * @returns Boolean | Integer
 * @private
 */
export const getNextTrackIndex = createSelector(
	getPlayqueueTracks,
	getPlayqueueIndex,
	(queue, currentIndex) => {
		const queueSize = queue.length
		let nextIndex = false
		if (currentIndex + 1 <= queueSize - 1) {
			nextIndex = currentIndex + 1
		}
		return nextIndex
	}
)

/**
 * Récupère le trackData de la prochaine track à lire, retourne false si c'est la même track,
 * retourne null si la track suivante est introuvable dans le dictionnaire
 *
 * @param state
 * @return Object: trackData | false | null
 */
export const getNextPlayqueueTrack = createSelector(
	getPlayqueueTracks,
	getNextTrackIndex,
	(queue, queueNextIndex) => {
		return queue[queueNextIndex] || false
	}
)

/**
 * Récupère l'id de la track dont l'index de playqueue est donné en paramètre (ou 'current')
 *
 * @param state
 *
 * @return Function with 1 parameter (index: Integer | 'current') => { number | null }
 */
export const getPlayqueueTrack = createSelector(
	getPlayqueueTracks,
	getPlayqueueIndex,
	(queue, currentIndex) => memoize(
		index => {
			if (queue.length > 0) {
				return index === 'current' && currentIndex > -1 ? queue[currentIndex] : queue[index]
			}
			return null
		}
	)
)


export const getPlayqueueTracksNumber = createSelector(
	(state) => getPlayqueueTracks(state).length,
	(number) => (number)
)

/**
 * Retourne si l'utilisateur est arrivé ou non à la fin de la file
 *
 * @param state
 * @returns Boolean
 *
 * @private
 */
export const canDoNext = createSelector(
	getPlayqueueTracks,
	getPlayqueueIndex,
	(queue, currentIndex) => {
		const queueSize = queue.length
		let can = false
		if (currentIndex + 1 <= queueSize - 1) {
			can = true
		}
		return can
	}
)



// WEBPACK FOOTER //
// ./src/components/miniPlayer/AudioPlayer/playerSelectors.js